import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import { getTranslation, type TranslationKey } from './translations';

interface LanguageContextType {
  language: string;
  setLanguage: (code: string) => void;
  t: (key: TranslationKey) => string;
}

const LanguageContext = createContext<LanguageContextType>({
  language: 'en-US',
  setLanguage: () => {},
  t: (key) => key,
});

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<string>(() => {
    try {
      return localStorage.getItem('cineverse-language') || 'en-US';
    } catch {
      return 'en-US';
    }
  });

  const setLanguage = (code: string) => {
    setLanguageState(code);
    try {
      localStorage.setItem('cineverse-language', code);
    } catch {}
  };

  const t = useCallback((key: TranslationKey) => getTranslation(language, key), [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
